import * as Yup from "yup";
import validationUtils from "./validationUtils.js";

const cartOrderDetailsSchema = Yup.object().shape({
  captcha_value: validationUtils?.validateCaptchaValue(),
});

export default cartOrderDetailsSchema;
